import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  triggerPopupDisplayScreenChange,
  triggerPopupCloseScreenChange,
} from '@axa-asia/hk-emma-web-module/lib/ga-lib/GaPreviousScreenUtil';
import {
  resolveLocalizedText,
  isApp,
  resolvePublicAssets,
  returnIsCICError,
  returnCICErrorMsg,
  validateStreeBuildingEstateValue,
  isOverLength,
} from '../../../../utils';
import classNames from 'classnames';
import { ChangeContactView } from '../../components/ChangeContactView';
import HappyHKCaseDialog from '../../components/ChangeAddressComponents/HappyHKCaseDialog';
import browserHistory from '../../../../stores/browserHistory';
import './style.scss';
import { t } from '../../../../locales';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import {
  GOOGLE_PLACE_AUTO_INPUT_ID,
  autocompleteOptions,
} from '../../sagas/changeAddressSaga';
import {
  loadGoogleAutoCompleteAddress,
  loadGoogleMapJsScript,
  setAddressForm,
  setIsAutoFilled,
  setIsChosenNonHKAddress,
  setIsClearSearchValue,
  setUpIsHKAddressCase,
  setUpShowAddressPopup,
  updateAddressOtherPolices,
  updateAddressSaveField,
  updateIsGoogleMapJsScriptError,
} from '../../actions/changeAddressAction';
import {
  getAddressText,
  getChangeAddressLabels,
  getChangeAddressStepContext,
  getIsGoogleMapJsScriptComplete,
  getIsHappyHKCase,
  getIsLoadingEditPage,
  getIsGoogleMapJsScriptError,
  getHKAddressInput,
  getIsShowAddressPopup,
  getIsConfirmLoadingButton,
  getAddressFromMapView,
  getIsChosenNonHKAddress,
  getIsClearSearchValue,
  getIsAutoFilled,
} from '../../selectors/changeAddressSelector';
import _, { debounce } from 'lodash';
import { getSelectedPolicy } from '../../selectors/changeContactSelector';
import { goto } from '../../../../actions/historyActions';
import { ADDRESS_HK_ENG } from '../../constants/constants';
import { getErrorCode } from '../../utils';
import LoadingView from '../../../../components/LoadingView';
import {
  EmmaIcon,
  EmmaSpace,
  EmmaText,
  EmmaTheme,
  EmmaDividerWithCenterText,
  EmmaStringTemplate,
  EmmaBackgroundButton,
  EmmaButton,
  EmmaInput,
  EmmaSearchBar,
  EmmaAutoCompleteSearch,
  EmmaAutoCompleteSearchRef,
} from '@axa-asia/emma-stylesheet';
import StreetMessageBanner from '../../components/StreetMessageBanner';
import Color from '@axa-asia/emma-stylesheet/styles/common/_color.scss';
import AddressAbbreviationListDialog from '../../components/ChangeAddressComponents/AddressAbbreviationListDialog';
import SameAddressDialog from '../../components/ChangeAddressComponents/SameAddressDialog';
import {
  HK_AREA_DISTRICT_MAPPING,
  SORTED_ADDRESS_ABBREVIATION_MAPPING,
} from '../../../../constants/constants';
import {
  AddressFormForUpdate,
  AddressInLines,
} from '../../types/changeAddressTypes';
import EmmaErrorModal from '../../../../components/EmmaErrorModal';
import ConfirmAddressDialog from '../../components/ChangeAddressComponents/ConfirmAddressDialog';
import AddressOutOfHKDialog from '../../components/ChangeAddressComponents/AddressOutOfHKDialog';
import { SearchableDataset } from '@axa-asia/emma-stylesheet/lib/components/EmmaMolecules/EmmaAutoCompleteSearch/search';
import {
  gaClickAbleElement,
  trackDisplayErrorSuccess,
} from '../../../../utils/generalGaEventAnalytics';

const MAX_FLAT_LENGTH = 4;
const MAX_FLOOR_LENGTH = 3;
const MAX_BLOCK_LENGTH = 4;
const MAX_STREET_BUILDING_ESTATE_LENGTH = 24;
const MAX_DISTRICT_LENGTH = 21;
const DISTRICT_ITEMS: SearchableDataset['items'] = [];
for (const area in HK_AREA_DISTRICT_MAPPING) {
  (HK_AREA_DISTRICT_MAPPING[area] as string[]).map((district) => {
    DISTRICT_ITEMS.push({
      key: district,
      en: district,
      zh: district,
    });
  });
}
const DISTRICT_AUTO_COMPLETE_DATASETS: SearchableDataset[] = [
  {
    rule: 'contains',
    items: DISTRICT_ITEMS,
  },
];
const FILL_NEW_ADDRESS_LABEL_ID =
  'edit-address-container-fill-new-address-label';

export interface EditAddressContainerProps {
  addressInput: {
    flat: string;
    block: string;
    floor: string;
    streetBuildingEstate1: string;
    streetBuildingEstate2: string;
    district: string;
  };
  changeAddressStepContext: any;
  editAddress: string;
  formFillingTitle: string;
  formFillingDescription: string;
  or: string;
  currentCorrespondenceAddress: string;
  chooseCurrentLocation: string;
  countryRegion: string;
  flatLabel: string;
  flatPlaceholder: string;
  floorLabel: string;
  floorPlaceholder: string;
  blockLabel: string;
  blockPlaceholder: string;
  streetBuildingEstateLabel: string;
  streetBuildingEstatePlaceholder1: string;
  streetBuildingEstatePlaceholder2: string;
  districtLabel: string;
  districtPlaceholder: string;
  searchNewAddress: string;
  remarkContact: string;
  contactUs: string;
  nextBtnLabel: string;
  oldAddress: string;
  selectedPolicy: {
    policyNumber: string;
  };
  hkEngAddress: any;
  isHappyHKCase: boolean;
  entityCode: string;
  isShowAddressPopup: boolean;
  isConfirmLoadingButton: boolean;
  noMatchAddress: string;
  enterEstateName: string;
  isGoogleMapJsScriptComplete: boolean;
  isLoadingEditPage: boolean;
  isGoogleMapJsScriptError: boolean;
  isChosenNonHKAddress: boolean;
  isClearSearchValue: boolean;
  isAutoFilled: boolean;
  loadGoogleAutoCompleteAddress: () => void;
  updateAddressOtherPolices: () => void;
  onSetUpIsHKAddressCase: (isHappyHKCase: boolean) => void;
  loadGoogleJsScript: () => void;
  onUpdateIsGoogleMapJsScriptError: (isError: boolean) => void;
  setAddressForm: (payload: AddressFormForUpdate) => void;
  onSetUpShowAddressPopup: (isShowAddressPopup: boolean) => void;
  onUpdateAddressSaveField: (payload: AddressInLines) => void;
  setIsChosenNonHKAddress: (isNonHK: boolean) => void;
  resetIsClearSearchValue: () => void;
  resetIsAutoFilled: () => void;
}

export interface EditAddressContainerState {
  bp: 'lg' | 'sm';
  isShowError: boolean;
  isFormValid: boolean;
  searchValue: string;
  isFlatError: boolean;
  flatErrorMsg: string;
  isBlockError: boolean;
  blockErrorMsg: string;
  isFloorError: boolean;
  floorErrorMsg: string;
  isStreetBuildingEstate1Error: boolean;
  streetBuildingEstate1ErrorMsg: string;
  isStreetBuildingEstate2Error: boolean;
  streetBuildingEstate2ErrorMsg: string;
  isDistrictError: boolean;
  districtErrMsg: string;
  isShowAddressAbbreviationDialog: boolean;
  isShowSameAddressDialog: boolean;
  districtOptionListHeight: number;
}

export class EditAddressContainer extends Component<
  EditAddressContainerProps,
  EditAddressContainerState
> {
  districtAutocompleteRef: React.RefObject<EmmaAutoCompleteSearchRef>;

  constructor(props: any) {
    super(props);
    this.districtAutocompleteRef = React.createRef<EmmaAutoCompleteSearchRef>();
    const {
      flat,
      block,
      floor,
      streetBuildingEstate1,
      streetBuildingEstate2,
      district,
    } = this.props.addressInput;
    const streeBuildingEstate1ErrorStste = validateStreeBuildingEstateValue(
      streetBuildingEstate1,
      MAX_STREET_BUILDING_ESTATE_LENGTH,
      true,
    );
    const streeBuildingEstate2ErrorStste = validateStreeBuildingEstateValue(
      streetBuildingEstate2,
      MAX_STREET_BUILDING_ESTATE_LENGTH,
      true,
    );
    this.state = {
      bp: 'lg',
      isFormValid: false,
      isShowError: false,
      searchValue: '',
      isFlatError: returnIsCICError(flat, MAX_FLAT_LENGTH),
      flatErrorMsg: returnCICErrorMsg(flat, MAX_FLAT_LENGTH),
      isBlockError: returnIsCICError(block, MAX_BLOCK_LENGTH),
      blockErrorMsg: returnCICErrorMsg(block, MAX_BLOCK_LENGTH),
      isFloorError: returnIsCICError(floor, MAX_FLOOR_LENGTH),
      floorErrorMsg: returnCICErrorMsg(floor, MAX_FLOOR_LENGTH),
      isStreetBuildingEstate1Error: streeBuildingEstate1ErrorStste.isError,
      streetBuildingEstate1ErrorMsg:
        streeBuildingEstate1ErrorStste.errorMessage,
      isStreetBuildingEstate2Error: streeBuildingEstate2ErrorStste.isError,
      streetBuildingEstate2ErrorMsg:
        streeBuildingEstate2ErrorStste.errorMessage,
      isShowAddressAbbreviationDialog: false,
      isDistrictError: returnIsCICError(
        district,
        MAX_DISTRICT_LENGTH,
        true,
        true,
      ),
      districtErrMsg: returnCICErrorMsg(
        district,
        MAX_DISTRICT_LENGTH,
        true,
        true,
      ),
      isShowSameAddressDialog: false,
      districtOptionListHeight: 0,
    };
  }

  componentDidMount() {
    this.updateBreakpoint();
    window.addEventListener('resize', this.updateBreakpoint);
    const { isGoogleMapJsScriptComplete, isHappyHKCase } = this.props;
    !isGoogleMapJsScriptComplete && this.props.loadGoogleJsScript();
    if (isApp()) {
      const title = t(`CUSTOMER_PROFILE_UPDATE_ADDRESS_TITLE`);
      EmmaFactory.createInstance().then((p) => {
        p.instance.showCloseButton();
        if (title) {
          p.instance.setNavigationTitle(title);
        }
      });
    }
    const { selectedPolicy, addressInput } = this.props;
    if (_.isEmpty(selectedPolicy)) {
      goto('emma-change-contact', undefined, undefined, true);
    } else {
      isGoogleMapJsScriptComplete && this.props.loadGoogleAutoCompleteAddress();
      if (isHappyHKCase) {
        triggerPopupDisplayScreenChange('HappyHKCase');
      }
    }
    if (!this.props.isChosenNonHKAddress) {
      this.districtAutocompleteRef?.current?.setInputValue(
        addressInput.district,
        true,
      );
    }
    this.updateIsFormValid();
    this.handleIsAutoFilled(100);
    this.handleChosenNonHKAddress();
  }

  componentDidUpdate(prevProps: Readonly<EditAddressContainerProps>) {
    if (prevProps.isClearSearchValue !== this.props.isClearSearchValue) {
      if (this.props.isClearSearchValue) {
        this.setState({ searchValue: '' });
        this.props.resetIsClearSearchValue();
      }
    }
    if (prevProps.addressInput.district !== this.props.addressInput.district) {
      this.handleDistrictChange();
    }
    if (prevProps.isAutoFilled !== this.props.isAutoFilled) {
      this.handleIsAutoFilled();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateBreakpoint);
  }

  handleChosenNonHKAddress = () => {
    if (this.props.isChosenNonHKAddress) {
      triggerPopupDisplayScreenChange('NonHKAddress');
      this.props.setAddressForm({
        flat: '',
        floor: '',
        block: '',
        streetBuildingEstate1: '',
        streetBuildingEstate2: '',
        district: '',
      });
    }
  };

  handleIsAutoFilled = (delayScrolling?: number) => {
    if (this.props.isAutoFilled) {
      this.props.resetIsAutoFilled();
      if (delayScrolling) {
        setTimeout(() => {
          this.scrollToFillAddressSection();
        }, delayScrolling);
        return;
      }
      this.scrollToFillAddressSection();
    }
  };

  scrollToFillAddressSection = () => {
    document
      .getElementById(FILL_NEW_ADDRESS_LABEL_ID)
      ?.scrollIntoView({ behavior: 'smooth' });
  };

  handleDistrictChange = () => {
    this.districtAutocompleteRef?.current?.setInputValue(
      this.props.addressInput.district,
      true,
    );
  };

  updateBreakpoint = debounce(() => {
    const isLg = Boolean(window.matchMedia(`(min-width: 768px)`)?.matches);
    this.setState({ bp: isLg ? 'lg' : 'sm' });
  }, 100);

  updateIsFormValid = () => {
    const { streetBuildingEstate1, streetBuildingEstate2, district } =
      this.props.addressInput;
    const {
      isFlatError,
      isFloorError,
      isBlockError,
      isStreetBuildingEstate1Error,
      isStreetBuildingEstate2Error,
      isDistrictError,
    } = this.state;

    if (
      isFlatError ||
      isFloorError ||
      isBlockError ||
      isStreetBuildingEstate1Error ||
      isStreetBuildingEstate2Error ||
      isDistrictError
    ) {
      this.setState({ isFormValid: false });
      return;
    }
    if ((!streetBuildingEstate1 && !streetBuildingEstate2) || !district) {
      this.setState({ isFormValid: false });
      return;
    }
    this.setState({ isFormValid: true });
  };

  onGoBack = () => {
    browserHistory.goBack();
  };

  checkPlacesServiceStatus() {
    const { onUpdateIsGoogleMapJsScriptError } = this.props;
    const tcWindow = window as any;
    const google = tcWindow && (tcWindow.google as any);
    if (google) {
      const input = document.getElementById(
        GOOGLE_PLACE_AUTO_INPUT_ID,
      ) as HTMLInputElement;
      const autocompleteService = new google.maps.places.AutocompleteService();
      autocompleteService.getPlacePredictions(
        { input: input.value, ...autocompleteOptions },
        (predictions: any, status: any) => {
          if (
            status === google.maps.places.PlacesServiceStatus.REQUEST_DENIED ||
            status === google.maps.places.PlacesServiceStatus.UNKNOWN_ERROR ||
            status === google.maps.places.PlacesServiceStatus.OVER_QUERY_LIMIT
          ) {
            onUpdateIsGoogleMapJsScriptError(true);
            const autoCompleteResultElement = (
              document as any
            ).getElementsByClassName('pac-container')[0];
            if (autoCompleteResultElement) {
              autoCompleteResultElement.style.display = 'none';
            }
          }
          const isShowError = !predictions || predictions.length === 0;
          this.setState({
            isShowError,
          });
        },
      );
    } else {
      onUpdateIsGoogleMapJsScriptError(true);
    }
  }

  onSearchInputChange = (searchValue: string) => {
    this.setState({
      searchValue,
    });
    if (!searchValue) {
      this.setState({
        isShowError: false,
      });
      return;
    }
    this.checkPlacesServiceStatus();
  };

  onChooseLocation = () => {
    goto('emma-customer-profile/changeaddress/chooselocation?type=edit');
  };

  onClickSetUpIsHKAddressCase = () => {
    triggerPopupCloseScreenChange();
    this.props.onSetUpIsHKAddressCase(false);
  };

  onFlatInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const flatValue = e.target.value;
    this.setState(
      {
        isFlatError: returnIsCICError(flatValue, MAX_FLAT_LENGTH),
        flatErrorMsg: returnCICErrorMsg(flatValue, MAX_FLAT_LENGTH),
      },
      () => this.updateIsFormValid(),
    );
    this.props.setAddressForm({ flat: flatValue });
  };

  onFloorInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const floorValue = e.target.value;
    this.setState(
      {
        isFloorError: returnIsCICError(floorValue, MAX_FLOOR_LENGTH),
        floorErrorMsg: returnCICErrorMsg(floorValue, MAX_FLOOR_LENGTH),
      },
      () => this.updateIsFormValid(),
    );
    this.props.setAddressForm({ floor: floorValue });
  };

  onBlockInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const blockValue = e.target.value;
    this.setState(
      {
        isBlockError: returnIsCICError(blockValue, MAX_BLOCK_LENGTH),
        blockErrorMsg: returnCICErrorMsg(blockValue, MAX_BLOCK_LENGTH),
      },
      () => this.updateIsFormValid(),
    );
    this.props.setAddressForm({ block: blockValue });
  };

  handleAddressAbbreviationShowHide = (isShow: boolean) => {
    if (isShow) {
      triggerPopupDisplayScreenChange('AddressAbbreviationGuideline');
    } else {
      triggerPopupCloseScreenChange();
    }
    this.setState({ isShowAddressAbbreviationDialog: isShow });
  };

  onStreetBuildingEstate1InputChange = (value: string) => {
    const { isError, errorMessage } = validateStreeBuildingEstateValue(
      value,
      MAX_STREET_BUILDING_ESTATE_LENGTH,
      true,
    );
    this.setState(
      {
        isStreetBuildingEstate1Error: isError,
        streetBuildingEstate1ErrorMsg: errorMessage,
      },
      () => this.updateIsFormValid(),
    );
    this.props.setAddressForm({ streetBuildingEstate1: value });
    return {
      value,
      isEmpty: !value,
      isError,
      isCorrect: false,
    };
  };

  onStreetBuildingEstate2InputChange = (value: string) => {
    const { isError, errorMessage } = validateStreeBuildingEstateValue(
      value,
      MAX_STREET_BUILDING_ESTATE_LENGTH,
      true,
    );
    this.setState(
      {
        isStreetBuildingEstate2Error: isError,
        streetBuildingEstate2ErrorMsg: errorMessage,
      },
      () => this.updateIsFormValid(),
    );
    this.props.setAddressForm({ streetBuildingEstate2: value });
    return {
      value,
      isEmpty: !value,
      isError,
      isCorrect: false,
    };
  };

  transferAddress = (address: string) => {
    return address.trim();
  };

  handleDistrictInputChange = (inputVal: string) => {
    this.setState(
      {
        isDistrictError: returnIsCICError(
          inputVal,
          MAX_DISTRICT_LENGTH,
          true,
          true,
        ),
        districtErrMsg: returnCICErrorMsg(
          inputVal,
          MAX_DISTRICT_LENGTH,
          true,
          true,
        ),
      },
      () => this.updateIsFormValid(),
    );
    this.props.setAddressForm({ district: inputVal });
  };

  handleDistrictOptionListHeightChange = (height: number) => {
    this.setState({ districtOptionListHeight: height });
  };

  handleCloseNonHKAddressPopup = () => {
    this.props.setIsChosenNonHKAddress(false);
    triggerPopupCloseScreenChange();
  };

  handleSubmit = () => {
    const { addressInput, oldAddress, onSetUpShowAddressPopup } = this.props;
    const {
      flat,
      floor,
      block,
      streetBuildingEstate1,
      streetBuildingEstate2,
      district,
    } = addressInput;
    const flatFloorBlockAddress = this.transferAddress(
      `${flat ? 'FLT ' + flat + ' ' : ''}${floor ? floor + '/F ' : ''}${
        block ? 'BLK ' + block + ' ' : ''
      }`,
    );
    const streetBuildingEstateAddress1 = this.transferAddress(
      streetBuildingEstate1,
    );
    const streetBuildingEstateAddress2 = this.transferAddress(
      streetBuildingEstate2,
    );
    const districtAddress = this.transferAddress(district.replace(/’/g, "'"));
    const country = 'HK';
    const currentAddress = `${flatFloorBlockAddress} ${streetBuildingEstateAddress1} ${streetBuildingEstateAddress2} ${districtAddress} ${country}`;
    if (oldAddress.toUpperCase() === currentAddress.toUpperCase()) {
      triggerPopupDisplayScreenChange('CICER23');
      // #70
      trackDisplayErrorSuccess('CICER23');
      // Same Address
      this.setState({
        isShowSameAddressDialog: true,
      });
      return;
    }
    this.props.onUpdateAddressSaveField({
      addrLine1: flatFloorBlockAddress.replace(/’/g, "'"),
      addrLine2: streetBuildingEstateAddress1.replace(/’/g, "'"),
      addrLine3: streetBuildingEstateAddress2.replace(/’/g, "'"),
      addrLine4: '',
      districtAddress,
      country,
    });
    onSetUpShowAddressPopup(true);
  };

  handleConfirm = () => {
    const { updateAddressOtherPolices } = this.props;
    updateAddressOtherPolices();
  };

  render() {
    const {
      addressInput,
      changeAddressStepContext,
      editAddress,
      formFillingTitle,
      formFillingDescription,
      or,
      currentCorrespondenceAddress,
      chooseCurrentLocation,
      countryRegion,
      flatLabel,
      flatPlaceholder,
      floorLabel,
      floorPlaceholder,
      blockLabel,
      blockPlaceholder,
      streetBuildingEstateLabel,
      streetBuildingEstatePlaceholder1,
      streetBuildingEstatePlaceholder2,
      districtLabel,
      districtPlaceholder,
      searchNewAddress,
      remarkContact,
      contactUs,
      nextBtnLabel,
      oldAddress,
      hkEngAddress,
      isHappyHKCase,
      entityCode,
      isShowAddressPopup,
      isConfirmLoadingButton,
      noMatchAddress,
      enterEstateName,
      isLoadingEditPage,
      isGoogleMapJsScriptError,
      isChosenNonHKAddress,
      setIsChosenNonHKAddress,
    } = this.props;
    const {
      bp,
      isShowError,
      isFormValid,
      searchValue,
      isFlatError,
      flatErrorMsg,
      isBlockError,
      blockErrorMsg,
      isFloorError,
      floorErrorMsg,
      streetBuildingEstate1ErrorMsg,
      streetBuildingEstate2ErrorMsg,
      isDistrictError,
      districtErrMsg,
      isShowAddressAbbreviationDialog,
      isShowSameAddressDialog,
    } = this.state;
    const resolvedStepContext = resolveLocalizedText(
      changeAddressStepContext,
    ) as any;

    return isLoadingEditPage ? (
      <LoadingView />
    ) : (
      <div className="edit-address-container">
        <ChangeContactView
          onGoBack={this.onGoBack}
          pageName={editAddress}
          stepContext={resolvedStepContext}
          activeIndex={0}
          isChangeAddress
        >
          <div className="content-align">
            <div className="emma-stylesheet-grid-system edit-address-container-content">
              <div className="edit-address-container-current-address-card">
                <EmmaIcon
                  iconKey="functional/location"
                  size={24}
                  color={EmmaTheme['icon/lightdark']}
                ></EmmaIcon>
                <div
                  className={classNames('d-flex flex-column', EmmaSpace.ml8)}
                >
                  <div
                    className={classNames(
                      EmmaText['Title_S/LooseContent/Left/MineShaft'],
                      EmmaSpace.mb4,
                    )}
                  >
                    {currentCorrespondenceAddress}
                  </div>
                  <div
                    className={EmmaText['BodyTextS/line-15em/Left/MineShaft']}
                  >
                    {oldAddress}
                  </div>
                </div>
              </div>
              <div className="edit-address-container-section">
                {!isGoogleMapJsScriptError && (
                  <div
                    className="edit-address-container-section-location content-align-level"
                    onClick={this.onChooseLocation}
                  >
                    <img
                      src={resolvePublicAssets(
                        `assets/images/customer-profile/dark.svg`,
                      )}
                      alt=""
                      data-enable-ga
                      data-ga-type="button"
                      data-ga-text={chooseCurrentLocation}
                    />
                    <div
                      className="edit-address-container-section-location-title"
                      data-enable-ga
                      data-ga-type="button"
                      data-ga-text={chooseCurrentLocation}
                    >
                      {chooseCurrentLocation}
                    </div>
                  </div>
                )}
                <div className="edit-address-container-section-form">
                  {!isGoogleMapJsScriptError && (
                    <>
                      <div
                        className={classNames(
                          EmmaText['Title_L/ComplexContent/Left/MineShaft'],
                          EmmaSpace.mt24,
                          EmmaSpace.mb8,
                        )}
                      >
                        {searchNewAddress}
                      </div>
                      <div className="edit-address-container-section-form-state-select">
                        <EmmaSearchBar
                          id={GOOGLE_PLACE_AUTO_INPUT_ID}
                          value={searchValue}
                          onChange={this.onSearchInputChange}
                          placeholder={enterEstateName}
                          isPersistLeadingIcon
                          isPressReturnToBlur
                          isError={isShowError}
                          errorMessage={noMatchAddress}
                          onPressReturn={(input) => {
                            this.onStreetBuildingEstate1InputChange(input);
                            this.setState(
                              {
                                searchValue: '',
                                isShowError: false,
                              },
                              () => {
                                this.scrollToFillAddressSection();
                              },
                            );
                          }}
                          enterKeyHint="search"
                        />
                      </div>
                      <EmmaDividerWithCenterText
                        className={classNames(EmmaSpace.mt24)}
                        content={or}
                      />
                    </>
                  )}
                  <div
                    id={FILL_NEW_ADDRESS_LABEL_ID}
                    className={classNames(
                      EmmaText['Title_L/LooseContent/Left/MineShaft'],
                      EmmaSpace.mt24,
                    )}
                  >
                    {formFillingTitle}
                  </div>
                  <div className={EmmaText['Remarks-L/Loose/Left/MineShaft']}>
                    {formFillingDescription}
                  </div>
                  <div
                    className={classNames(
                      EmmaSpace.mt16,
                      EmmaSpace.mb8,
                      EmmaText['Title_L/ComplexContent/Left/MineShaft'],
                    )}
                  >
                    {countryRegion}
                  </div>
                  <div className="edit-address-container-section-form-country-input">
                    <input
                      id="country"
                      className="emma-stylesheet-input-disable-field col-12"
                      type="text"
                      defaultValue="Hong Kong"
                      placeholder="Hong Kong"
                      disabled
                    />
                  </div>
                  <div className={EmmaSpace.mt16}>
                    <div className="row">
                      <div className="emma-stylesheet-label col-12">
                        <label
                          className="emma-stylesheet-label__text"
                          htmlFor="Flat"
                        >
                          {flatLabel}
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className={`col-12 ${
                          isFlatError
                            ? 'emma-stylesheet-input-error'
                            : EmmaSpace.mb16
                        }`}
                      >
                        <input
                          id="Flat"
                          className={`emma-stylesheet-input-field col-12 ${
                            isFlatError
                              ? 'emma-stylesheet-input-error-field'
                              : ''
                          }`}
                          type="text"
                          value={addressInput.flat}
                          onChange={this.onFlatInputChange}
                          placeholder={flatPlaceholder}
                        />
                      </div>
                    </div>
                    {isFlatError && (
                      <div className="row">
                        <div
                          className={classNames(
                            'emma-stylesheet-input-tip-error col-12',
                            EmmaSpace.mb8,
                          )}
                        >
                          {flatErrorMsg}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="edit-address-container-section-form-fb">
                    <div
                      className={classNames(
                        'edit-address-container-section-form-fb-floor-input',
                        {
                          'edit-address-container-section-form-fb-floor-input-error':
                            isFloorError,
                        },
                      )}
                    >
                      <div className="row">
                        <div className="emma-stylesheet-label col-12">
                          <label
                            className="emma-stylesheet-label__text"
                            htmlFor="Floor"
                          >
                            {floorLabel}
                          </label>
                        </div>
                      </div>
                      <div className="row">
                        <div
                          className={`edit-address-container-section-form-fb-floor-input-content col-12 ${
                            isFloorError ? 'emma-stylesheet-input-error' : ''
                          }`}
                        >
                          <input
                            id="Floor"
                            className={`emma-stylesheet-input-field col-12 ${
                              isFloorError
                                ? 'emma-stylesheet-input-error-field'
                                : ''
                            }`}
                            type="text"
                            value={addressInput.floor}
                            onChange={this.onFloorInputChange}
                            placeholder={floorPlaceholder}
                          />
                          <span
                            className={classNames(
                              'edit-address-container-section-form-fb-floor-input-content-unit',
                              {
                                [EmmaSpace.mr24]: isFloorError,
                              },
                            )}
                          >
                            /F
                          </span>
                        </div>
                      </div>
                      {isFloorError && (
                        <div className="row">
                          <div className="emma-stylesheet-input-tip-error col-12">
                            {floorErrorMsg}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="edit-address-container-section-form-fb-block-input">
                      <div className="row">
                        <div className="emma-stylesheet-label col-12">
                          <label
                            className="emma-stylesheet-label__text"
                            htmlFor="Block"
                          >
                            {blockLabel}
                          </label>
                        </div>
                      </div>
                      <div className="row">
                        <div
                          className={`edit-address-container-section-form-fb-block-input col-12 ${
                            isBlockError ? 'emma-stylesheet-input-error' : ''
                          }`}
                        >
                          <input
                            id="Block"
                            className={`emma-stylesheet-input-field col-12 ${
                              isBlockError
                                ? 'emma-stylesheet-input-error-field'
                                : ''
                            }`}
                            type="text"
                            value={addressInput.block}
                            onChange={this.onBlockInputChange}
                            placeholder={blockPlaceholder}
                          />
                        </div>
                      </div>
                      {isBlockError && (
                        <div className="row">
                          <div className="emma-stylesheet-input-tip-error col-12">
                            {blockErrorMsg}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    className={
                      EmmaText['Title_L/ComplexContent/Left/MineShaft']
                    }
                  >
                    {streetBuildingEstateLabel}
                    <span style={{ color: Color.shyTomato }}>*</span>
                  </div>
                  <StreetMessageBanner
                    className={EmmaSpace.mt8}
                    onContentClick={() => {
                      if (isApp()) {
                        goto(
                          'emma-customer-profile/changeaddress/abbreviation',
                        );
                      } else {
                        this.handleAddressAbbreviationShowHide(true);
                      }
                    }}
                  />
                  <EmmaInput
                    childrenClassName={EmmaSpace.mt8}
                    value={addressInput.streetBuildingEstate1}
                    onHandleCustomValidation={(val) =>
                      this.onStreetBuildingEstate1InputChange(val)
                    }
                    placeholder={streetBuildingEstatePlaceholder1}
                    isShowPlaceholderWhenFocus
                    errorMessage={streetBuildingEstate1ErrorMsg}
                    enableCount
                    isCustomValidation
                    isValidateInitValue
                    maxLength={MAX_STREET_BUILDING_ESTATE_LENGTH}
                    skipCharacterCountRightSpacing
                    allowExceedMaxLength
                  />
                  <EmmaInput
                    childrenClassName={EmmaSpace.mt8}
                    value={addressInput.streetBuildingEstate2}
                    onHandleCustomValidation={(val) =>
                      this.onStreetBuildingEstate2InputChange(val)
                    }
                    placeholder={streetBuildingEstatePlaceholder2}
                    isShowPlaceholderWhenFocus
                    errorMessage={streetBuildingEstate2ErrorMsg}
                    enableCount
                    isCustomValidation
                    isValidateInitValue
                    maxLength={MAX_STREET_BUILDING_ESTATE_LENGTH}
                    skipCharacterCountRightSpacing
                    allowExceedMaxLength
                  />
                  <EmmaAutoCompleteSearch
                    ref={this.districtAutocompleteRef}
                    containerClassName={classNames(
                      EmmaSpace.mt16,
                      'edit-address-container-mb0',
                    )}
                    datasets={DISTRICT_AUTO_COMPLETE_DATASETS}
                    label={districtLabel}
                    isRequired
                    showGlassIcon={false}
                    showCloseIcon={false}
                    isPressEnterToDismiss
                    maxItems={5}
                    inputFieldProps={{
                      placeholder: resolveLocalizedText(districtPlaceholder),
                      isShowPlaceholderWhenFocus: true,
                      isError: isDistrictError,
                      errorMessage: districtErrMsg,
                      type: 'text',
                    }}
                    onPureInputChange={this.handleDistrictInputChange}
                    onOptionListHeightChanged={
                      this.handleDistrictOptionListHeightChange
                    }
                  ></EmmaAutoCompleteSearch>
                  <div
                    style={{ height: this.state.districtOptionListHeight }}
                  ></div>
                </div>
                <EmmaStringTemplate
                  className={classNames(
                    EmmaText['BodyTextS/line-15em/Left/MineShaft'],
                    EmmaSpace.mt24,
                  )}
                  template={remarkContact}
                  items={{
                    contactUs: {
                      text: contactUs,
                      style: {
                        color: Color.indigo,
                        cursor: 'pointer',
                      },
                      onClick: () => {
                        gaClickAbleElement(contactUs);
                        if (isApp()) {
                          const { policyNumber } = this.props.selectedPolicy;
                          EmmaFactory.createInstance().then((emma) => {
                            emma.instance.goTo(
                              `emma-life/support?policyNumber=${policyNumber}&isHideTopbarBackButton=true`,
                            );
                          });
                        } else {
                          goto('emma-life/support');
                        }
                      },
                    },
                  }}
                />
                {bp === 'lg' && (
                  <EmmaButton
                    className={EmmaSpace.mt16}
                    disabled={!isFormValid}
                    isFullWidth
                    onClick={this.handleSubmit}
                  >
                    {nextBtnLabel}
                  </EmmaButton>
                )}
              </div>
            </div>
          </div>
        </ChangeContactView>
        {/* Happy HK case */}
        <HappyHKCaseDialog />
        {bp === 'sm' && (
          <EmmaBackgroundButton
            label={nextBtnLabel}
            isDisabled={!isFormValid}
            onClick={this.handleSubmit}
            buttonClassName={classNames('edit-address-container-nextBtn-sm')}
          />
        )}
        {!isApp() && (
          <AddressAbbreviationListDialog
            isShow={isShowAddressAbbreviationDialog}
            onClose={() => this.handleAddressAbbreviationShowHide(false)}
          />
        )}
        <SameAddressDialog
          isShow={isShowSameAddressDialog}
          onClose={() => this.setState({ isShowSameAddressDialog: false })}
        />
        <ConfirmAddressDialog
          isShow={isShowAddressPopup}
          isLoading={isConfirmLoadingButton}
          onConfirm={this.handleConfirm}
          onClose={() => this.props.onSetUpShowAddressPopup(false)}
        />
        <AddressOutOfHKDialog
          isShow={isChosenNonHKAddress}
          onClose={this.handleCloseNonHKAddressPopup}
        />
        <EmmaErrorModal />
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const changeAddressStepContext = getChangeAddressStepContext(state);
    const changeAddressLabels = getChangeAddressLabels(state);
    const oldAddress = getAddressText(state);
    const selectedPolicy = getSelectedPolicy(state);
    const hkEngAddress = getErrorCode(ADDRESS_HK_ENG, state);
    const {
      editAddress,
      formFillingTitle,
      formFillingDescription,
      or,
      currentCorrespondenceAddress,
      chooseCurrentLocation,
      countryRegion,
      flat,
      flatPlaceholder,
      floor,
      floorPlaceholder,
      block,
      blockPlaceholder,
      streetBuildingEstate,
      streetBuildingEstatePlaceholder1,
      streetBuildingEstatePlaceholder2,
      district,
      districtPlaceholder,
      searchNewAddress,
      remarkContact,
      contactUs,
      noMatchAddress,
      enterEstateName,
      nextBtnLabel,
    } = changeAddressLabels;
    const addressFromMapView = getAddressFromMapView(state);
    return {
      addressInput: getHKAddressInput(state),
      changeAddressStepContext,
      editAddress: editAddress ? resolveLocalizedText(editAddress) : '',
      formFillingTitle: formFillingTitle
        ? resolveLocalizedText(formFillingTitle)
        : '',
      formFillingDescription: formFillingDescription
        ? resolveLocalizedText(formFillingDescription)
        : '',
      or: resolveLocalizedText(or),
      currentCorrespondenceAddress: currentCorrespondenceAddress
        ? resolveLocalizedText(currentCorrespondenceAddress)
        : '',
      chooseCurrentLocation: chooseCurrentLocation
        ? resolveLocalizedText(chooseCurrentLocation)
        : '',
      countryRegion: countryRegion ? resolveLocalizedText(countryRegion) : '',
      flatLabel: resolveLocalizedText(flat),
      flatPlaceholder: resolveLocalizedText(flatPlaceholder),
      floorLabel: resolveLocalizedText(floor),
      floorPlaceholder: resolveLocalizedText(floorPlaceholder),
      blockLabel: resolveLocalizedText(block),
      blockPlaceholder: resolveLocalizedText(blockPlaceholder),
      streetBuildingEstateLabel: resolveLocalizedText(streetBuildingEstate),
      streetBuildingEstatePlaceholder1: resolveLocalizedText(
        streetBuildingEstatePlaceholder1,
      ),
      streetBuildingEstatePlaceholder2: resolveLocalizedText(
        streetBuildingEstatePlaceholder2,
      ),
      districtLabel: resolveLocalizedText(district),
      districtPlaceholder: resolveLocalizedText(districtPlaceholder),
      searchNewAddress: searchNewAddress
        ? resolveLocalizedText(searchNewAddress)
        : '',
      remarkContact: remarkContact ? resolveLocalizedText(remarkContact) : '',
      contactUs: resolveLocalizedText(contactUs),
      nextBtnLabel: resolveLocalizedText(nextBtnLabel),
      noMatchAddress: noMatchAddress
        ? resolveLocalizedText(noMatchAddress)
        : '',
      oldAddress,
      selectedPolicy,
      hkEngAddress,
      isHappyHKCase: getIsHappyHKCase(state),
      entityCode:
        !!selectedPolicy &&
        !!selectedPolicy.policy &&
        !!selectedPolicy.policy.entityCode
          ? selectedPolicy.policy.entityCode
          : '',
      enterEstateName: enterEstateName
        ? resolveLocalizedText(enterEstateName)
        : '',
      isShowAddressPopup: getIsShowAddressPopup(state),
      isConfirmLoadingButton: getIsConfirmLoadingButton(state),
      isGoogleMapJsScriptComplete: getIsGoogleMapJsScriptComplete(state),
      isLoadingEditPage: getIsLoadingEditPage(state),
      isGoogleMapJsScriptError: getIsGoogleMapJsScriptError(state),
      addressFromMapView,
      isChosenNonHKAddress: getIsChosenNonHKAddress(state),
      isClearSearchValue: getIsClearSearchValue(state),
      isAutoFilled: getIsAutoFilled(state),
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      loadGoogleAutoCompleteAddress: () => {
        dispatch(loadGoogleAutoCompleteAddress());
      },
      updateAddressOtherPolices: () => {
        dispatch(updateAddressOtherPolices());
      },
      onSetUpIsHKAddressCase: (isHappyHKCase: boolean) => {
        dispatch(setUpIsHKAddressCase(isHappyHKCase));
      },
      loadGoogleJsScript: () => {
        dispatch(loadGoogleMapJsScript());
      },
      onUpdateIsGoogleMapJsScriptError: (isError: boolean) => {
        dispatch(updateIsGoogleMapJsScriptError(isError));
      },
      setAddressForm: (payload: AddressFormForUpdate) => {
        dispatch(setAddressForm(payload));
      },
      onSetUpShowAddressPopup: (isShowAddressPopup: boolean) => {
        dispatch(setUpShowAddressPopup(isShowAddressPopup));
      },
      onUpdateAddressSaveField: (payload: AddressInLines) => {
        dispatch(updateAddressSaveField(payload));
      },
      setIsChosenNonHKAddress: (isNonHK: boolean) => {
        dispatch(setIsChosenNonHKAddress(isNonHK));
      },
      resetIsClearSearchValue: () => {
        dispatch(setIsClearSearchValue(false));
      },
      resetIsAutoFilled: () => {
        dispatch(setIsAutoFilled(false));
      },
    };
  }
}

export default connect(
  EditAddressContainer.mapStateToProps,
  EditAddressContainer.mapDispatchToProps,
)(EditAddressContainer);
